import {
  Autocomplete,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { getPlacesForText } from "../../../../../services/rest/mapbox/getPlaces";
import FmdGoodIcon from "@mui/icons-material/FmdGood";

const InputSearchPlace = ({
  searchText = "",
  setSearchText,
  onPlaceSelect,
  mapRef,
}) => {
  const [optionsPlaces, setOptionsPlaces] = useState([]);

  const getPlaces = async (text) => {
    try {
      if (text === "") {
        return;
      }
      const response = await getPlacesForText({ text });
      setOptionsPlaces(response ?? []);
    } catch (error) {
      throw error;
    }
  };

  const handleSearch = async (text) => {
    try {
      setSearchText(text);
      await getPlaces(text);
    } catch (error) {
      toast.error("No se encontraron resultados. \nIntentalo más tarde.");
    }
  };

  return (
    <Box>
      <TextField
        label="Ubicación de club"
        name="descriptionLocation"
        variant="outlined"
        value={searchText}
        style={{
          borderRadius: 5,
          width: 300,
        }}
        onChange={(e) => handleSearch(e.target.value)}
      />
      <Box
        sx={{
          width: "100%",
          maxWidth: 360,
          bgcolor: "background.paper",
          position: "absolute",
          zIndex: 1,
        }}
      >
        {optionsPlaces.length > 0 &&
          optionsPlaces.map(
            (place, key) =>
              place?.properties?.full_address && (
                <List key={key}>
                  <ListItem>
                    <ListItemButton
                      onClick={() => {
                        const coordinates = [
                          place?.properties?.coordinates?.longitude,
                          place?.properties?.coordinates?.latitude,
                        ];
                        const address =
                          place?.properties?.full_address ??
                          place?.properties?.address;

                        onPlaceSelect(coordinates, address);
                        setOptionsPlaces([]);
                      }}
                    >
                      <ListItemIcon>
                        <FmdGoodIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={`${place?.properties?.full_address}`}
                      />
                    </ListItemButton>
                  </ListItem>
                </List>
              )
          )}
      </Box>
    </Box>
  );
};

export default InputSearchPlace;
